import { Box, Button, Grid, Stack, Typography } from '@mui/material'
import React from 'react'
import MainCard from 'ui-component/cards/MainCard'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { IoMdArrowRoundBack } from "react-icons/io";
import { useState } from 'react';
import { useEffect } from 'react';
import { getAllUnmappedCsp, PostRmUpdatedAmount } from 'API/CspMapping/api';
import BackdropLoader from '../../General/Loader';
import SnackBar from '../../General/SnackBar';
import UnMappedAgentTable from './UnMappedCspTable';
import ApprovalDialog from './ApprovalDialog';
import Modal from '@mui/material/Modal';
import { IoClose } from "react-icons/io5";
import RmApproveDialog from './RmApprovalDialog';
import ApprovalHistory from './ApprovalHistoryModal';
import ReajectReason from '../Components/ReajectReasonBox';
import { CsoApproveRequest, RejectCspmapping } from 'API/DS_Wallet/api';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};


const ApprovePage = (props) => {

    const [Data, setData] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [ErrorMessage, setErrorMessage] = useState(null)
    const [AlertType, setAlertType] = useState("success")
    const [AlertOpen, setAlertOpen] = useState(false)

    const [openApprovalDialog, setApprovalDialog] = useState(false)
    const [SelectedData, setSelectedData] = useState(null)
    const [viewLocations, setViewLocations] = useState(false)
    const [RmpostData, setRmpostData] = useState(null)
    const [OpenConfirmApprove, setConfirmApprove] = useState(false)
    const [OpenApprovalHistory, setOpenApprovalHistory] = useState(false)
    const [AgentDetails, setAgentDetails] = useState(null)
    const [openReject, setOpenReject] = useState(false)
    const [RejectReason, setRejectReason] = useState('')


    const handleRejectOpen = () => {
        setOpenReject(true)
    }

    const handleRejectClose = () => {
        setOpenReject(false)
    }

    const handleReject = () => {
        console.log("rejected", RejectReason, props);
        if (RejectReason && RejectReason !== "") {
            RejectCspmapping({ request_id: props.userData.request_id, rejected_reason: RejectReason }, setIsLoading, handleErrorOpen)
        }
        else {
            handleErrorOpen("Please enter reason for rejection", "error")
        }
    }


    const handleOpenApprovalHistory = () => {
        setOpenApprovalHistory(true)
    }

    const handleCloseApprovalClose = () => {
        setOpenApprovalHistory(false)
    }

    const handleOpenViewModal = () => {
        setViewLocations(true)
    }

    const handleCloseViewModal = () => {
        setViewLocations(false)
    }


    const handleErrorOpen = (message, type) => {
        setErrorMessage(message)
        setAlertType(type)
        setAlertOpen(true)
    }


    useEffect(() => {
        if (sessionStorage.getItem("UserType") === "sh" && props.type==='pending') {
            getAllUnmappedCsp(props.userData, setIsLoading, setData, handleErrorOpen)
        }
    }, [])

    const handleAlertClose = () => {
        setAlertOpen(false)
    }

    const handleApprovalDialogClose = () => {
        setApprovalDialog(false)
    }


    const handleApproveRequest = () => {
        let length = Object.keys(SelectedData).length;
        if (length > 0) {
            let allAmount = Object.entries(SelectedData).every(([key, value]) => {
                if (key) {
                    return Object.prototype.hasOwnProperty.call(value, "sh_amount") && (value["sh_amount"] !== null && value["sh_amount"] !== "");
                }
            });
            if (allAmount) {
                setApprovalDialog(true)
            }
            else {
                handleErrorOpen("Please fill the amount for all selected csp", "error")
            }
        }
        else {
            handleErrorOpen("Please select csp to map", "error")
        }

    }

    const handleCsoApprove = () => {
        setConfirmApprove(true)
    }

    const handleConfirmApproveOpen = () => {
        setConfirmApprove(true);
    }

    const handleConfirmApproveClose = () => {
        setConfirmApprove(false);
    }

    const handleRMApprove = () => {
        if (sessionStorage.getItem("UserType") === "rm") {
            let updatedArray = Object.entries(RmpostData).map(([key, value]) => {
                return { user_id: key, rm_amount: value };
            });
            // console.log(updatedArray, SelectedData, RmpostData, props);
            let postData = {
                "request_id": props.userData.request_id,
                "ds_id": props.userData.ds_id,
                "agent_data": updatedArray
            }

            PostRmUpdatedAmount(postData, setIsLoading, handleErrorOpen)
        }
        else {
            let postData = { "request_id": props.userData.request_id }
            CsoApproveRequest(postData, setIsLoading, handleErrorOpen)
        }
    }


    console.log("props", props);


    return (
        <Grid container>
            <ReajectReason rejectReason={RejectReason} open={openReject} handleClose={handleRejectClose} setRejectReason={setRejectReason} handleReject={handleReject} />
            <RmApproveDialog open={OpenConfirmApprove} handleClose={handleConfirmApproveClose} handleSubmit={handleRMApprove} />
            <ApprovalDialog dsdata={props.userData} data={SelectedData} open={openApprovalDialog} handleClose={handleApprovalDialogClose} />
            <ApprovalHistory data={AgentDetails} open={OpenApprovalHistory} handleClose={handleCloseApprovalClose} />
            <BackdropLoader open={isLoading} />
            <SnackBar open={AlertOpen} message={ErrorMessage} type={AlertType} handleClose={handleAlertClose} />
            <Grid item xl={12} lg={12}>
                <Button onClick={() => props.handleClose()} sx={{ fontSize: "20px" }}>
                    <IoMdArrowRoundBack />
                </Button>
                <MainCard>
                    <Modal
                        open={viewLocations}
                        onClose={handleCloseViewModal}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}>
                            <Box onClick={() => handleCloseViewModal()} sx={{ position: 'absolute', top: 5, right: 5, fontSize: '25px', cursor: 'pointer' }}>
                                <IoClose />
                            </Box>
                            <Typography id="modal-modal-description" >
                                {props ? props.userData.ds_allocated_location.map((item) => item.District).join(" , ") : null}
                            </Typography>
                        </Box>
                    </Modal>
                    <Grid container>
                        <Grid item xl={12} lg={12}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table" size='small'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ width: "30%" }} align="center">Name</TableCell>
                                            <TableCell sx={{ width: "30%" }} align="center">Type</TableCell>
                                            <TableCell sx={{ width: "40%" }} align="center">Location</TableCell>
                                            {
                                                sessionStorage.getItem("UserType") === "cso" ?
                                                    <TableCell sx={{ width: "10%" }} align="center">History</TableCell>
                                                    :
                                                    null
                                            }
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ width: "30%" }} align="center">{props.userData.ds_details.username}</TableCell>
                                            <TableCell sx={{ width: "30%" }} align="center">DS</TableCell>
                                            <TableCell align="center" sx={{ width: '50%', height: "1000%" }}>
                                                {/* <Box sx={{ display: 'flex', width: "100%",flexWrap:'wrap' }}> */}
                                                <Button onClick={() => handleOpenViewModal()}>view</Button>
                                                {/* </Box> */}
                                            </TableCell>
                                            {
                                                sessionStorage.getItem('UserType') === 'cso' ?
                                                    <TableCell>
                                                        <Button onClick={() => handleOpenApprovalHistory()} >
                                                            view
                                                        </Button>
                                                    </TableCell>
                                                    :
                                                    null
                                            }
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </MainCard>
            </Grid>
            <Grid item xl={12} lg={12} mt={1}>
                <UnMappedAgentTable status={props.type} setAgentDetails={setAgentDetails} setRmpostData={setRmpostData} userDetails={props.userData} setSelectedData={setSelectedData} data={Data ? Data.data : null} />
            </Grid>
            <Grid item xl={12} lg={12} mt={2}>
                {
                    props && props.userData && (props.userData.sh_approved === false && sessionStorage.getItem("UserType") === 'sh') && props.type==='pending'?
                        <Stack direction="row" justifyContent="center" gap={1}>
                            <Button variant="contained" color="success" onClick={() => handleApproveRequest()} >
                                Approve
                            </Button>
                            <Button variant="contained" color="error" onClick={() => handleRejectOpen()} >
                                Reject
                            </Button>
                        </Stack>
                        :
                        sessionStorage.getItem("UserType") === 'rm' && props.type==='pending'?
                            <Stack direction="row" justifyContent="center" gap={1}>
                                <Button variant="contained" color="success" onClick={() => handleConfirmApproveOpen()} >
                                    Forward request to CSO
                                </Button>
                            </Stack>
                            :
                            sessionStorage.getItem("UserType") === "cso" && props.type==='pending'?
                                <Stack direction="row" justifyContent="center" gap={1}>
                                    <Button variant="contained" color="success" onClick={() => handleCsoApprove()} >
                                        Approve
                                    </Button>
                                    <Button variant="contained" color="error" onClick={() => handleRejectOpen()} >
                                        Reject
                                    </Button>
                                </Stack>
                                :
                                null
                }
            </Grid>
        </Grid>
    )
}

export default ApprovePage